import { UI, HStack, VStack } from '@genial/components';
import { BoxRadius, Spacing } from '@genial/design-tokens';
import { Utils } from '@genial/utils';
import React, { useEffect } from 'react';

import { InputMoney } from '../../../../../../../../../components/InputMoney';
import { ResponsiveSuccessIconButton } from '../../../../../../../../../components/ResponsiveSuccessIconButton';
import { useDirectTreasuryAssetController } from '../../../../../hooks/products/DirectTreasury';
import { LateralBar } from '../../../components/LateralBar';

import { DirectTreasuryItemSelectedTypes } from '.';

export const DirectTreasuryItemSelectedMobile: React.FC<DirectTreasuryItemSelectedTypes.Props> = ({
  offer,
  onUpdate,
  hideLateralBar = false,
}) => {
  const id = offer.productIdNormalized;
  const {
    control,
    amountItem,
    currentValue,
    currentValueFormatted,
    handleChangeAmountItem,
    handleInputBlur,
    handleInputClear,
    handleInputFocus,
    handleSubmit,
    hasError,
    helpText,
    helpTextProps,
    isFocused,
    showMessageAdjustUnitPrice,
  } = useDirectTreasuryAssetController(offer);

  useEffect(() => {
    if (offer.orderValue === currentValue || !currentValue) {
      return;
    }
    const updatedOffer = {
      ...offer,
      orderValue: currentValue || 0,
      orderQuantity: amountItem || 0.01,
    };
    onUpdate(updatedOffer);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentValue]);

  const middleInfos = [
    {
      label: 'Data da aplicação',
      value: (
        <UI.Text color="neutral.dark">{Utils.Mask.DateFormat(new Date(), 'dd/MM/yyyy')}</UI.Text>
      ),
    },
    {
      label: 'Aplicação em',
      value: <UI.Text color="neutral.dark">{offer.settlementDateFormattedNormalized}</UI.Text>,
    },
    {
      label: 'Investimento mínimo',
      value: <UI.Text color="neutral.dark">{Utils.Mask.Money(offer.minimumApplication)}</UI.Text>,
    },
  ];

  return (
    <VStack space="stack.xxxs" w="full">
      {!hideLateralBar && (
        <LateralBar
          backgroundColor="product.rf"
          borderTopLeftRadius={BoxRadius.sm}
          borderBottomLeftRadius={BoxRadius.sm}
        />
      )}
      <VStack space="stack.nano">
        <UI.Text variant="semibold" color="neutral.black">
          {offer.productNameNormalized}
        </UI.Text>
      </VStack>
      <VStack space="stack.nano" flexGrow={1}>
        {middleInfos.map(({ label, value }) => (
          <HStack space="inline.quarck" justifyContent="space-between" key={label}>
            <UI.Text color="neutral.black" variant="semibold">
              {label}
            </UI.Text>
            {value}
          </HStack>
        ))}
      </VStack>
      <VStack space={Spacing['stack.quarck']} flexGrow={1}>
        <UI.Text color="neutral.black" variant="semibold">
          Quantidade
        </UI.Text>
        <VStack flex={1}>
          <UI.InputStepper
            stepperValue={0.01}
            max={1000000}
            min={offer.minimumStepQuantity || 0}
            name="treasury-amount-order-input"
            keyboardType="numeric"
            defaultValue={amountItem || 0}
            onChange={handleChangeAmountItem}
            showErrorMessage={false}
          />
        </VStack>
      </VStack>
      <HStack
        space={Spacing['inline.xxxs']}
        justifyContent="space-between"
        w="full"
        alignItems="flex-end">
        <VStack space={Spacing['stack.quarck']} flexGrow={1}>
          <UI.Text color="neutral.black" variant="semibold">
            Valor a aplicar
          </UI.Text>
          <VStack flex={1}>
            <InputMoney
              id={`directTreasury-input${id}`}
              name="priceItem"
              control={control}
              handleFocus={handleInputFocus}
              handleBlur={handleInputBlur}
              handleSubmit={handleSubmit}
              handleClear={handleInputClear}
              currentValue={currentValueFormatted}
              hasFocus={isFocused}
              minValue={offer.minimumApplication || 0}
              customInputProps={{
                ...{
                  ...(showMessageAdjustUnitPrice && {
                    helpTextProps,
                    helpText,
                  }),
                },
                ...{ ...(isFocused && hasError && { error: hasError }) },
                ...{ ...(isFocused && !hasError && { helpText }) },
              }}
            />
          </VStack>
        </VStack>
        <ResponsiveSuccessIconButton />
      </HStack>
    </VStack>
  );
};
